import { useState } from "react";
import { Dialog } from "@mui/material";
import { CustomTextField } from "../../../mui/Input";
import { CloseButton, ConfirmButton } from "../../../mui/button/Button";

const PromotePopup = ({ id, heading, subtext, onConfirm, onClose }) => {
    const [remark, setRemark] = useState('');

    return (
        <Dialog open={true} onClose={onClose}>
            <div className="flex flex-col p-6 gap-8 w-full sm:w-fit bg-white rounded-lg">
                <div className="flex sm:w-[30rem] gap-5">
                    <img className="col-span-2 w-12 h-12" alt="" loading="eager" src='/icons/tabs/Edit.svg' />
                    <div >
                        <h2 className="h4-p">{heading}</h2>
                        <p className="text-s">{subtext}</p>
                    </div>
                </div>

                <div className="flex flex-col gap-5 w-full">
                    <CustomTextField fullWidth value={remark} multiline rows={5} onChange={e => setRemark(e.target.value)} placeholder='Add a remark for promotion' />
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-5">
                        <CloseButton fullWidth size="large" text="Cancel" onClick={onClose} />
                        <ConfirmButton fullWidth size="large" text="Confirm" onClick={() => onConfirm(id, remark)} />
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default PromotePopup;